import {Button, Form, Input, InputNumber, Modal, ModalProps, Space} from "antd";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/sample";
import * as sampleQuotaApi from "../../apis/sampleDealerQuota";

import StandardTable, {StandardColumnsType} from "../StandardTable";
import {RowSelectionType, TableRowSelection} from "antd/lib/table/interface";
import {useEffect, useState} from "react";
import * as React from "react";
import {useRequest} from "ahooks";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {Decimal} from "decimal.js";


interface SampleSelectModalProps extends ModalProps {
    contractId: String,
    dealerId?: any,
    multiple?: boolean
    columns?: StandardColumnsType
    onComplete?: (keys?: number[], records?: any[]) => void
    url?: string
    queryParams?: any
    searchColumns?: StandardColumnsType
}

function SampleSelectModal(props: SampleSelectModalProps) {
    const userDealerId = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.dealerId
    const {onCancel, onOk, onComplete, columns = [], ...otherProps} = props;
    const [dealerId, setDealerId] = useState<any>(userDealerId);
    const [dealerQuota, setDealerQuota] = useState<any>(0);
    const [selectedQuota, setSelectedQuota] = useState<any>(0);
    const {
        tableProps,
        form,
        search
    } = useAntTable(props.url ? props.url : api.getSampleListByContractUrl, {
        selectTable: props.multiple ? true : 'radio',
        defaultParams: {...props?.queryParams || {}, contractId: props.contractId}
    });
    useEffect(() => {
        form.setFieldsValue(props.queryParams);
        search.submit();
    }, [props.queryParams]);

    const {loading: loadingQuotaGet, run: runQuotaGet} = useRequest(sampleQuotaApi.getDealerQuotaByDealer, {
        manual: true,
        onSuccess(res) {
            setDealerQuota(res.data.data.amount || 0);
        }
    });


    const tableColumns = columns.length ? columns : [
        {
            dataIndex: 'productCode',
            key: 'productCode',
            title: '商品编码',
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            title: '商品名称',
        },
        {
            dataIndex: 'specification',
            key: 'specification',
            title: '商品规格',
        },
        {
            dataIndex: 'price',
            key: 'price',
            title: '售价',
        },
        {
            dataIndex: 'qty',
            key: 'qty',
            title: '数量',
            render(v: any, r: any, i: number) {
                return (<InputNumber step={1} min={1} value={v} onChange={v => {
                    r.qty = v
                    calcSelectedQuota();
                }}/>)
            }
        }
    ];

    useEffect(() => {
        const d = props.dealerId ? props.dealerId : dealerId;
        if (otherProps) {
            resetSelected()
        }
        if (otherProps.open && d) {
            runQuotaGet(d);
        }
    }, [otherProps.open]);

    useEffect(() => {
        calcSelectedQuota();
    }, [tableProps.rowSelection.selectedRowKeys]);


    const handleOk = (e: React.MouseEvent<HTMLButtonElement>) => {
        onOk && onOk(e)
        onComplete && onComplete(tableProps?.rowSelection?.selectedRowKeys, tableProps?.rowSelection?.selectedRows);
    }
    const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
        onCancel && onCancel(e);
    }

    const resetSelected = () => {
        tableProps?.rowSelection?.onChange([], []);
    }



    const calcSelectedQuota = ()=>{
        const selected =  tableProps?.rowSelection.selectedRows;
        const result = selected.map((o:any)=>new Decimal(o.qty||0).mul(o.price||0)).reduce((p1=new Decimal(0) ,p2=new Decimal(0))=>{
            return p1.add(p2);
        },new Decimal(0));
        setSelectedQuota(result.toString());
    }

    const toolbar =
        <Space style={{flex: 1}}>
            <Form form={form} disabled={false}>
                <Space>
                    <Form.Item name={'productCode'} style={{marginBottom: 0}}>
                        <Input placeholder={'请输入商品编号或名称'} allowClear/>
                    </Form.Item>
                    <Button onClick={search.reset}>重置</Button>
                    <Button type={"primary"} onClick={search.submit} loading={tableProps.loading}>搜索</Button>
                </Space>
            </Form>
            <Space style={{color: 'var(--danger-color)'}}>
                <span>
                客户样品额度：{loadingQuotaGet ? '载入中' : dealerQuota}
                </span>
                &nbsp;
                <span>
                选中样品额度：{selectedQuota}
                </span>
            </Space>

        </Space>

    return <Modal title={'样品选择'} {...otherProps} width={1000} onOk={handleOk} onCancel={handleCancel}
                  destroyOnClose>
        <StandardTable {...tableProps} rowKey={'id'} submit={search.submit} form={form}
                       columns={tableColumns} search={search}
                       toolbar={toolbar}
        />
    </Modal>
}

export default SampleSelectModal;